import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import qs from 'qs'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

export const getCategories = () => (dispatch) => {
  dispatch({type: 'GET_NEWS_CATEGORY_LIST_PENDING'});
  return irelandApi.get('/api/admin/news_categories')
                   .then((response) => {
                     dispatch({type: 'GET_NEWS_CATEGORY_LIST_FULFILLED', payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_NEWS_CATEGORY_LIST_REJECTED', payLoad: error.data})
                   })
};

export const getCategory = (id) => (dispatch) => {
  dispatch({type: "GET_NEWS_CATEGORY_PENDING"});
  return irelandApi.get(`/api/admin/news_categories/${id}`)
                   .then((response) => {
                     const attributes = response.data.data.attributes;
                     const category = {
                       name: attributes.name || ''
                     };
                     dispatch(actions.load('deep.admin_news.category', category));
                     dispatch({type: "GET_NEWS_CATEGORY_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_NEWS_CATEGORY_REJECTED', payLoad: error.data})
                   })
};

export const deleteCategory = (id) => (dispatch) => {
  dispatch({type: "DELETE_NEWS_CATEGORY_PENDING"});
  return irelandApi.delete(`/api/admin/news_categories/${id}`)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="News category has been deleted successfully"/>);
                     dispatch({type: "DELETE_NEWS_CATEGORY_FULFILLED", payLoad: id});
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occured during delete news category"/>);
                     dispatch({type: 'DELETE_NEWS_CATEGORY_REJECTED', payLoad: error.data});
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};

export const saveCategory = (payLoad) => {
  return irelandApi.post('/api/admin/news_categories/', {'news_category': payLoad})
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="News category has been saved successfully"/>);
                     history.push('/admin/news/categories');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during save news category"/>);
                     store.dispatch(actions.resetValidity('deep.admin_news.category'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};

export const updateCategory = (id, payLoad) => {
  return irelandApi.patch(`/api/admin/news_categories/${id}`, {'news_category': payLoad})
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="News category has been saved successfully"/>);
                     history.push('/admin/news/categories');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during save news category"/>);
                     store.dispatch(actions.resetValidity('deep.admin_news.category'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};

export const getArticles = (query, dateFrom, dateTo, status) => (dispatch) => {
  dispatch({type: 'GET_NEWS_ARTICLE_LIST_PENDING'});
  const q = {
    title:             query,
    display_from_date: dateFrom,
    display_to_date:   dateTo,
    status:            status
  };
  return irelandApi.get(`/api/admin/articles/?${qs.stringify({q: q}, {encodeValuesOnly: true})}`)
                   .then((response) => {
                     dispatch({type: 'GET_NEWS_ARTICLE_LIST_FULFILLED', payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_NEWS_ARTICLE_LIST_REJECTED', payLoad: error.data})
                   })
};

export const getArticle = (id) => (dispatch) => {
  dispatch({type: "GET_NEWS_ARTICLE_PENDING"});
  const suffix = id ? id : 'new';
  return irelandApi.get(`/api/admin/articles/${suffix}`)
                   .then((response) => {
                     const collectPermissions = permissions => {
                       const permission_ids = {};

                       if(permissions){
                         permissions.forEach(item => {
                           item.children.forEach(perm => {
                             permission_ids[perm.id] = {
                               name:    perm.name,
                               checked: perm.checked
                             }
                           })
                         });
                       }

                       return permission_ids;
                     };

                     if (response.data.data) {
                       const attributes = response.data.data.attributes;
                       let permission_ids = collectPermissions(attributes.permissions);

                       const createGroupList = (groups) => {
                         return attributes['all-groups'] ?
                           [{label: 'All', value: 'all'}] :
                           groups.map((curr) => {
                             return {
                               label: `${curr.name}`,
                               value: curr.id
                             }
                           });
                       };

                       const article = {
                         title:              attributes.title,
                         news_category_id:   attributes['news-category-id'],
                         status:             attributes.status,
                         display_from_date:  attributes['display-from-date'],
                         display_to_date:    attributes['display-to-date'],
                         featured:           attributes.featured.toString(),
                         linked_article_ids: attributes['linked-articles'],
                         permission_ids:     permission_ids,
                         group_ids:          createGroupList(attributes['group-ids'])
                       };

                       dispatch(actions.load('deep.admin_news.article', article));
                     } else {
                       let permission_ids = collectPermissions(response.data.meta.permissions);
                       dispatch(actions.change('deep.admin_news.article.permission_ids', permission_ids));
                     }
                     dispatch({type: "GET_NEWS_ARTICLE_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_NEWS_ARTICLE_REJECTED', payLoad: error.data})
                   })
};

export const deleteArticle = (id) => (dispatch) => {
  dispatch({type: "DELETE_NEWS_ARTICLE_PENDING"});
  return irelandApi.delete(`/api/admin/articles/${id}`)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="News article has been deleted successfully"/>);
                     dispatch({type: "DELETE_NEWS_ARTICLE_FULFILLED", payLoad: id});
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occured during delete news article"/>);
                     dispatch({type: 'DELETE_NEWS_ARTICLE_REJECTED', payLoad: error.data});
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};

const createGroupIdList = (groups) => ({
  group_ids: groups.map(group => +group.value)
});

const createAllGroupAttribute = (groups) => ({
  all_groups: allGroup(groups)
});

const allGroup = (groups) => !!groups.find(group => group.value === 'all');

const transformArticle = (payLoad) => {
  const mPayLoad = {
    ...payLoad,
    linked_article_ids: payLoad.linked_article_ids.map(article => +article.value),
    group_ids: payLoad.group_ids.map(group => +group.value),
    permission_ids: [],
    ...createAllGroupAttribute(payLoad.group_ids),
    ...createGroupIdList(payLoad.group_ids),
  };

  if(allGroup(payLoad.group_ids)) {
    delete mPayLoad['group_ids'];
  }

  Object.keys(payLoad.permission_ids).forEach(function (key) {
    if(payLoad.permission_ids[key].checked){
      mPayLoad.permission_ids.push(+key);
    }
  });

  return mPayLoad;
};

const assembleFormData = (article) => {
  let formData = new FormData();
  Object.keys(article).forEach(key => {
    if(article[key] instanceof Array){
      article[key].forEach(item => {
        formData.append(`article[${key}][]`, item)
      })
    } else {
      formData.append(`article[${key}]`, article[key])
    }
  });

  return formData;
};

export const saveArticle = (payLoad) => {
  let article = transformArticle(payLoad);
  let formData = assembleFormData(article);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.post(`/api/admin/articles/`, formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="News article has been saved successfully"/>);
                     history.push('/admin/news/articles');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during save news article"/>);
                     store.dispatch(actions.resetValidity('deep.admin_news.article'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};

export const updateArticle = (id, payLoad) => {
  let article = transformArticle(payLoad);
  let formData = assembleFormData(article);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.put(`/api/admin/articles/${id}`, formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="News article has been saved successfully"/>);
                     history.push('/admin/news/articles');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during save news article"/>);
                     store.dispatch(actions.resetValidity('deep.admin_news.article'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};



// WEBPACK FOOTER //
// ./src/actions/news.js